import Vue from 'vue';
import VueTippy from 'vue-tippy';

import VueCurrencyFilter from 'vue-currency-filter';

import ApartmentsList from '../vue/components/ApartmentsList.vue';
import PopupContainer from '../vue/components/PopupContainer.vue';

import initGallery from '../components/gallery';
import initAbout from '../components/about';
import initMap from '../components/map';
import initMenu from '../components/menu';
import initStandard from '../components/standard';
import initFormFill from '../components/formFill';

import initTracking from '../components/tracking';
import { fetchInvestmentData } from '../components/fetchHistory';

export default {
  init() {
    const investmentId = '01991168-9bd9-711f-a548-da536a3a0ba8';
    // JavaScript to be fired on all pages
    initGallery();
    initAbout();
    initMap();
    initMenu();
    initStandard();
    initFormFill();

    Vue.use(VueTippy);
    Vue.component('apartment-list', ApartmentsList);
    Vue.component('popup-container', PopupContainer);

    Vue.use(VueCurrencyFilter, {
      symbol: 'zł',
      thousandsSeparator: ' ',
      fractionCount: 2,
      fractionSeparator: ',',
      symbolPosition: 'back',
      symbolSpacing: true,
    });

    if ($('#apartmentList').length > 0) {
      new Vue({
        el: '#apartmentList',
      });
    }

    if ($('#popupContainer').length > 0) {
      new Vue({
        el: '#popupContainer',
      });
    }

    fetchInvestmentData(investmentId).then(res => {
      console.log(res);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    initTracking();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js